<template>
    <div :class="['myGrades', {'print': isPrint}]" ref="print-content">
        <el-row>
            <el-col :span="24">
                <div class="information">
                    <div class="informationCenter">
                        <div class="informationTitle">
                            <Title text="我的学习成绩" />
                        </div>
                        <div class="elTabs">
                            <!-- 认定课程 -->
                            <!-- <el-tabs v-model="activeName">
                <el-tab-pane label="认定课程" name="examination"> -->
                            <div class="informationDescribe" v-show="!isPrint">
                                <p>
                                    温馨提示：如考试未通过，请点击 “
                                    <span class="primary">复查</span>“只能对考试成绩进行复查，缺考成绩为0分
                                </p>
                            </div>
                            <div class="informationDiv" v-show="!isPrint">
                                <el-table slot="list" :data="disGeneralDataList" headerRowClassName="uni-primary-table-header" stripe border>
                                    <el-table-column prop="course.code" align="center" label="课程代码"></el-table-column>
                                    <el-table-column prop="course.title" align="center" label="课程名称"></el-table-column>
                                    <el-table-column align="center" label="课程总成绩">
                                        <template slot-scope="props">
                                            <span v-if="props.row.is_assess == 0">无考核</span>
                                            <span v-else>{{ props.row.score_total }}</span>
                                        </template>
                                    </el-table-column>
                                    <el-table-column v-if="_ENTRANCETYPE=='adult'" align="center" label="平时成绩">
                                        <template slot-scope="props">
                                            <span v-if="props.row.is_assess == 0">无考核</span>
                                            <span v-else>{{ props.row.peacetime_score }}</span>
                                        </template>
                                    </el-table-column>
                                    <el-table-column v-if="_ENTRANCETYPE=='own'" align="center" width="100px" label="章节作业成绩">
                                        <template slot-scope="props">
                                            <span v-if="props.row.is_assess == 0">无考核</span>
                                            <span v-else>{{ props.row.work_score }}</span>
                                        </template>
                                    </el-table-column>
                                    <el-table-column v-if="_ENTRANCETYPE=='own'" align="center" label="已学课时占比得分">
                                        <template slot-scope="scope">
                                            <p>{{ scope.row.learn_hours_mix }}</p>
                                        </template>
                                    </el-table-column>
                                    <el-table-column v-if="_ENTRANCETYPE=='own'" align="center" label="已学课时">
                                        <template slot-scope="scope">
                                            <p>{{ scope.row.learn_hour }}</p>
                                        </template>
                                    </el-table-column>

                                    <el-table-column v-if="_ENTRANCETYPE=='own'" width="180" align="center" label="考试成绩占比得分">
                                        <template slot-scope="props">
                                            <span v-if="props.row.is_assess == 0">无考核</span>
                                            <span v-else>
                                                线上考试成绩：{{ props.row.exam_line_mix }}
                                                <br />
                                                线下考试成绩：{{ props.row.exam_offline_mix }}
                                            </span>
                                        </template>
                                    </el-table-column>
                                    <el-table-column width="150" align="center" label="考试成绩">
                                        <template slot-scope="props">
                                            <div v-if="_ENTRANCETYPE=='own'">
                                                <span v-if="props.row.is_assess == 0">无考核</span>
                                                <span v-else>
                                                    线上考试成绩：{{ props.row.exam_line_score }}
                                                    <br />
                                                    线下考试成绩：{{ props.row.exam_offline_score }}
                                                </span>
                                            </div>
                                            <div v-else>
                                                {{ props.row.exam_score === -1 ? '未考试' : props.row.exam_score }}
                                            </div>
                                        </template>
                                    </el-table-column>

                                    <el-table-column align="center" label="课程成绩构成" width="350">
                                        <template slot-scope="props">
                                            <span v-if="props.row.is_assess == 0">无考核</span>
                                            <div v-else>
                                                <span>{{ props.row.scoreInfo }}</span>
                                            </div>
                                        </template>
                                    </el-table-column>
                                    <el-table-column align="center" label="最终成绩">
                                        <template slot-scope="props">
                                            <span v-if="props.row.is_assess == 0">无考核</span>
                                            <span v-else>{{ props.row.score }}</span>
                                        </template>
                                    </el-table-column>
                                    <el-table-column align="center" label="操作" width="250" v-show="!isPrint">
                                        <template slot-scope="props">
                                            <div v-if="
                                                props.row.is_assess == 1 &&
                                                props.row.is_score_review == 1
                                            ">
                                                <el-button 
                                                    class="link-btn myGrades-review" 
                                                    v-if="props.row.score_review == 0" 
                                                    type="primary" 
                                                    @click="sendMsg(props.row.course_id, props.$index)">复查</el-button>
                                                <span v-else>等待老师查询</span>
                                            </div>
                                            <div v-else>--</div>
                                        </template>
                                    </el-table-column>
                                </el-table>
                            </div>
                            <div class="table" v-show="isPrint">
                                <div class="table-header">
                                    <div class="item header-item">课程代码</div>
                                    <div class="item header-item">课程名称</div>
                                    <div class="item header-item">课程总成绩</div>
                                    <div class="item header-item" v-if="_ENTRANCETYPE=='adult'">平时成绩</div>
                                    <div class="item header-item" v-if="_ENTRANCETYPE=='own'">章节作业成绩</div>
                                    <div class="item header-item" v-if="_ENTRANCETYPE=='own'">已学课时占比得分</div>
                                    <div class="item header-item" v-if="_ENTRANCETYPE=='own'">已学课时</div>
                                    <div class="item header-item" v-if="_ENTRANCETYPE=='own'">考试成绩占比得分</div>
                                    <div class="item header-item">考试成绩</div>
                                    <div class="item header-item">课程成绩构成</div>
                                    <div class="item header-item">最终成绩</div>
                                </div>
                                <div class="list" v-for="(item, index) in disGeneralDataList" :key="index">
                                    <div class="item call-item">{{item.course.code}}</div>
                                    <div class="item call-item">{{item.course.title}}</div>
                                    <div class="item call-item">
                                        <span v-if="item.is_assess == 0">无考核</span>
                                        <span v-else>{{ item.score_total }}</span>
                                    </div>
                                    <div class="item call-item" v-if="_ENTRANCETYPE=='adult'">
                                        <span v-if="item.is_assess == 0">无考核</span>
                                        <span v-else>{{ item.peacetime_score }}</span>
                                    </div>
                                    <div class="item call-item" v-if="_ENTRANCETYPE=='own'">
                                        <span v-if="item.is_assess == 0">无考核</span>
                                        <span v-else>{{ item.work_score }}</span>
                                    </div>
                                    <div class="item call-item" v-if="_ENTRANCETYPE=='own'">
                                        <p>{{ item.learn_hours_mix }}</p>
                                    </div>
                                    <div class="item call-item" v-if="_ENTRANCETYPE=='own'">
                                        <p>{{ item.learn_hour }}</p>
                                    </div>
                                    <div class="item call-item" v-if="_ENTRANCETYPE=='own'">
                                        <span v-if="ClipboardItem.is_assess == 0">无考核</span>
                                        <span v-else>
                                            线上考试成绩：{{ item.exam_line_mix }}
                                            <br />
                                            线下考试成绩：{{ item.exam_offline_mix }}
                                        </span>
                                    </div>
                                    <div class="item call-item">
                                        <div v-if="_ENTRANCETYPE=='own'">
                                            <span v-if="item.is_assess == 0">无考核</span>
                                            <span v-else>
                                                线上考试成绩：{{ item.exam_line_score }}
                                                <br />
                                                线下考试成绩：{{ item.exam_offline_score }}
                                            </span>
                                        </div>
                                        <div v-else>
                                            {{ item.exam_score === -1 ? '未考试' : item.exam_score }}
                                        </div>
                                    </div>
                                    <div class="item call-item">
                                        <span v-if="item.is_assess == 0">无考核</span>
                                        <div v-else>
                                            <span>{{ item.scoreInfo }}</span>
                                        </div>
                                    </div>
                                    <div class="item call-item">
                                        <span v-if="item.is_assess == 0">无考核</span>
                                        <span v-else>{{ item.score }}</span>
                                    </div>
                                </div>
                                </div>
                            <!-- </el-tab-pane> -->
                            <!-- 国考课程 -->
                            <!--<el-tab-pane label="国考课程" name="exam">
                  <div class="informationDiv">
                    <el-table
                      slot="list"
                      :data="dataList"
                      headerRowClassName="uni-primary-table-header"
                      stripe
                      border
                    >
                      <el-table-column
                        prop="code"
                        align="center"
                        label="课程代码"
                      ></el-table-column>
                      <el-table-column
                        prop="title"
                        align="center"
                        label="课程名称"
                      ></el-table-column>
                      <el-table-column
                        prop="score"
                        align="center"
                        label="我的考试成绩"
                      ></el-table-column>
                    </el-table>
                  </div>
                </el-tab-pane>-->
                            <!-- </el-tabs> -->
                        </div>
                        <div class="promptDownload" v-show="!isPrint">
                            <p v-if="_ENTRANCETYPE=='adult'" style="cursor: pointer" @click="downLoadGrade">
                                确认无误后下载成绩单
                            </p>
                            <span>如对考试有疑问，请联系老师处理</span>
                        </div>
                    </div>
                </div>
            </el-col>
        </el-row>
    </div>
</template>

<script>
import { myTkScore, myRDScore, courseReview } from "@/api/basic";
import { downLoadFiles } from "@/utils/func";
import { mapState } from "vuex";

export default {
    name: "myGrades",
    data() {
        return {
            // activeName: "examination",
            dataList: [],
            disGeneralDataList: [],
            exam_status: [
                "-",
                "报名待审核",
                "缴费审核失败",
                "待考试",
                "阅卷中",
                "缺考",
                "考试完成",
            ],
            isPrint: false,  //打印
        };
    },
    computed: {
        ...mapState("permission", {
            _ENTRANCETYPE: (state) => state._ENTRANCETYPE,
        }),
    },
    mounted() {
        this.getDisGeneralData();
        // this.getData();
    },
    methods: {
        // 统考成绩
        async getData() {
            const { result } = await myTkScore();
            if (result) {
                this.dataList = result;
            }
        },
        // 非统考成绩
        async getDisGeneralData() {
            const { result } = await myRDScore();
            if (result) {
                this.disGeneralDataList = result;
            }
        },
        // 复查
        /*async sendMsg(examId, index) {
      if (!examId) {
        return;
      }

      const res = await examReview({ exam_line_id: examId });
      if (res.code == 200) {
        this.$message({
          message: "发送成功",
          type: "success",
        });
        document.querySelectorAll(".myGrades-review")[index].disabled = true;
      }
    },*/
        async sendMsg(course_id, index) {
            if (!course_id) {
                return;
            }

            const res = await courseReview({ course_id: course_id });
            if (res.code == 200) {
                this.$message({
                    message: "申请成功，等待老师查询",
                    type: "success",
                });
                document.querySelectorAll(".myGrades-review")[
                    index
                ].disabled = true;
            }
        },
        /**
         * 下载成绩单
         */
        async downLoadGrade() {
            this.isPrint = true;
            setTimeout(() => {
                this.$print(this.$refs['print-content'])  //打印
                this.isPrint = false;
            });
            // if (
            //     (this.activeName == "examination" &&
            //         (!this.disGeneralDataList ||
            //             this.disGeneralDataList.length == 0)) ||
            //     (this.activeName == "exam" &&
            //         (!this.dataList || this.dataList.length == 0))
            // ) {
            //     this.$message.warning("暂时没有数据可以下载");
            //     return;
            // }

            // 下载todo
        },
    },
};
</script>

<style lang="scss" scoped>
.information {
    min-height: $contentH;
    padding: 20px 20px 0 20px;
    /deep/ .el-table .cell {
        padding: 5px 0;
    }
}
.informationCenter {
    width: 100%;
    min-height: inherit;
    background-color: #fff;
}
.informationTitle {
    display: flex;
    align-items: center;
}
.elTabs {
    padding: 0 20px;
}
.informationTitle span {
    display: inline-block;
    width: 4px;
    height: 23px;
    background-color: #1459a6;
}
.informationTitle {
    padding-left: 20px;
}
.informationDiv {
    width: 100%;
    margin-top: 28px;
}
.informationDescribe {
    display: flex;
    margin-top: 30px;
}
.informationDescribe p {
    font-size: 14px;
    color: #666;
    margin-left: 25px;
}
.informationDescribe p span {
    font-size: 14px;
    @include fontColor("primary");
}
.promptDownload {
    padding: 0 20px;
    display: flex;
    justify-content: space-between;
    margin: 20px 0;
}
.promptDownload p {
    color: #fa9050;
    font-size: 14px;
}
.promptDownload span {
    color: #9a9a9a;
    font-size: 15px;
}
.link-btn {
    height: 30px;
    padding-top: 0;
    padding-bottom: 0;
}

// 打印样式
$border-color-print: #999;
.examRoomUsageAE.print{
  
}
.myGrades{
    &.print{
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
    }
  .table{
    border: 1px solid $border-color-print;
    border-right: none;
    .table-header{
      display: flex;
      border-bottom: 1px solid $border-color-print;
      .header-item{
        color: #909399;
        font-weight: bold;
      }
    }
    .list{
      border-bottom: 1px solid $border-color-print;
      display: flex;

      &:last-child{
        border-bottom: none;
      }
      .call-item{
        color: #606266;
      }
    }
    .item{
      flex: 1;
      padding: 12px 10px;
      text-align: center;
      font-size: 14px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: normal;
      word-break: break-all;
      line-height: 23px;
      border-right: 1px solid $border-color-print;
      display: flex;
      align-items: center;
      justify-content: center;
      // &:last-child{
      //   border-right: none;
      // }
    }
  }
}
</style>
